import { sendUtagEvent } from '../../core/analytics/utag_events'
import on from '../../utils/events_delegation'

export function initializeUtagEvents() {
  document.querySelector('.utag-footer-download-app')?.addEventListener('click', e => {
    sendUtagEvent({
      data: {
        event_name: 'download_app',
        event_cat: 'click download app',
        event_act: '',
        event_lbl: '',
        event_purpose: 'loyalty',
        event_structure: 'footer',
      },
    })
  })

  on({
    eventName: 'click',
    selector: '.utag-footer-cookies-config',
    handler() {
      sendUtagEvent({
        data: {
          event_name: 'cookie_policy',
          event_cat: 'cookie policy',
          event_act: 'manage configuration',
          event_lbl: '',
          event_purpose: 'information',
          event_structure: 'footer',
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.utag-footer-legal-links .cookie-policy',
    handler() {
      sendUtagEvent({
        data: {
          event_name: 'cookie_policy',
          event_cat: 'cookie policy',
          event_act: 'cookie detail',
          event_lbl: '',
          event_purpose: 'information',
          event_structure: 'footer',
        },
      })
    },
  })

  const contactLinkBenefit = document.querySelector('.footer-benefit-contact')

  contactLinkBenefit?.addEventListener('click', function () {
    sendUtagEvent({
      data: {
        event_name: 'call_click_contact',
        event_cat: 'call center',
        event_act: 'click contact button',
        event_lbl: '',
        event_purpose: 'information',
        event_structure: 'body',
      },
    })
  })

  const buttonMoreInformationExclusiveBenefit = document.querySelector('.button-benefit-call-to-action')

  function clickbuttonMoreInformationExclusiveBenefit(button, data) {
    button.addEventListener('click', function () {
      const pageData = {
        page_category: 'other',
        page_section: 'offers',
        page_type: 'iberostar exclusive benefits',
      }
      Object.assign(data, pageData)
    })
  }

  if (buttonMoreInformationExclusiveBenefit) {
    clickbuttonMoreInformationExclusiveBenefit(buttonMoreInformationExclusiveBenefit, {})
  }
}
